import {
    GET_JOBTITLE_REQUEST,
    GET_JOBTITLE_SUCCESS,
    GET_JOBTITLE_ERROR,

} from "../types"
import axios from "axios";
import { BASEURL } from "../../../constant/config.js"



export const loadJobTitle = (token) => dispatch => {
    dispatch({ type: GET_JOBTITLE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminJob`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_JOBTITLE_SUCCESS, payload: response.data });
        })

        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_JOBTITLE_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_JOBTITLE_ERROR,
                payload: error.response,
            });
        })
};

